// @flow
import apiService from './auth-api-service';
import config from '../config';

class MapleIntegrationService {
  authorizeMaple = (params: string): Promise<> => {
    return apiService.post(`/integrations/maple${params}`);
  };

  connectToMaple = () => {
    const urlParams = new URLSearchParams();
    urlParams.set('redirect_uri', `${config.ORIGIN}/profile/integrations?`);
    return apiService.get(`/integrations/connect/maple?${urlParams.toString()}`).then((data) => {
      window.location.href = data.url;
    });
  };

  disconnectFromMaple = (integrationId) => {
    return apiService.delete(`/integrations/${integrationId}`);
  }
}

export default new MapleIntegrationService();


// WEBPACK FOOTER //
// ./src/services/maple-integration-service.js